import React from 'react';
import { Section, Card, Countdown } from './Shared';
export const ProductDetails = () => {
  return <>
      {/* Tomos Section */}
      <Section bg="dark" data-id="element-274" data-mp="18f7a71ic4pjn">
        <div className="text-center mb-12" data-id="element-275" data-mp="18hjrrdk6kxw6">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold mb-4" data-id="element-276" data-mp="un9blkm92c1q">
            📚 6 TOMOS COMPLETOS
          </h2>
          <p className="font-montserrat text-xl text-brand" data-id="element-277" data-mp="zlu93ca4ahmh">
            Todo listo para aplicar desde hoy
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-278" data-mp="pp7u344h2ksd">
          <Card className="bg-[#2A2A2A] border-gray-700 text-base transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-279" data-mp="pmv17vx6eq0j">
            <h3 className="font-playfair text-xl font-bold mb-3 text-brand" data-id="element-280" data-mp="gnrhqqu3k8li">
              📕 TOMO 1<br data-id="element-281" data-mp="262xy6avld920" />
              El Arte de Cobrar Caro
            </h3>
            <p className="font-montserrat text-sm text-gray-300 mb-4" data-id="element-282" data-mp="261mwcglpibdj">
              El sistema para valorizar tu trabajo y comunicar precios con seguridad. Mentalidad, comunicación de valor y scripts exactos para presentar tu calidad.
            </p>
            <p className="font-montserrat text-sm italic text-gray-400" data-id="element-283" data-mp="146gzwhjgwzl9">
              "Hoy comunico mi precio con total seguridad."
            </p>
          </Card>

          <Card className="bg-[#2A2A2A] border-gray-700 text-base transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-284" data-mp="1d03rdvgn7gon">
            <h3 className="font-playfair text-xl font-bold mb-3 text-brand" data-id="element-285" data-mp="pb10dx04cbhh">
              📗 TOMO 2<br data-id="element-286" data-mp="l9piyereewkd" />
              50 Scripts de Reels
            </h3>
            <p className="font-montserrat text-sm text-gray-300 mb-4" data-id="element-287" data-mp="z85ow3hfsj1g">
              50 guiones listos para grabar, copiar y publicar. Sin bloqueo
              creativo. Sin improvisar frente a la cámara.
            </p>
            <p className="font-montserrat text-sm italic text-gray-400" data-id="element-288" data-mp="2amsygjq7cjhd">
              "Por fin sé exactamente qué decir."
            </p>
          </Card>

          <Card className="bg-[#2A2A2A] border-gray-700 text-base transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-289" data-mp="25qvgk8zaj52h">
            <h3 className="font-playfair text-xl font-bold mb-3 text-brand" data-id="element-290" data-mp="2hq0ud5a743kr">
              📘 TOMO 3<br data-id="element-291" data-mp="2mpdidtcszgox" />
              Historias que Venden
            </h3>
            <p className="font-montserrat text-sm text-gray-300 mb-4" data-id="element-292" data-mp="2mo2ezun9sayc">
              El sistema de las 3 historias diarias y los 5 tipos de historia
              que más venden en estética. Scripts exactos para cada una.
            </p>
            <p className="font-montserrat text-sm italic text-gray-400" data-id="element-293" data-mp="1yzj73g84u06s">
              "Empecé a recibir consultas sin pedir nada."
            </p>
          </Card>

          <Card className="bg-[#2A2A2A] border-gray-700 text-base transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-294" data-mp="28q410qcv2gjd">
            <h3 className="font-playfair text-xl font-bold mb-3 text-brand" data-id="element-295" data-mp="1b9ou8yntcbmj">
              📙 TOMO 4<br data-id="element-296" data-mp="1g99vxguday2y" />
              WhatsApp Closer
            </h3>
            <p className="font-montserrat text-sm text-gray-300 mb-4" data-id="element-297" data-mp="1g7gldqgmvtpo">
              Scripts para responder consultas, presentar precios, manejar el
              "lo pienso" y cerrar turnos sin sentirte pesada.
            </p>
            <p className="font-montserrat text-sm italic text-gray-400" data-id="element-298" data-mp="yrl1o2dfgmcu">
              "Ahora respondo con seguridad. Nada de dudas."
            </p>
          </Card>

          <Card className="bg-[#2A2A2A] border-gray-700 text-base transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-299" data-mp="tvdu655dv2ss">
            <h3 className="font-playfair text-xl font-bold mb-3 text-brand" data-id="element-300" data-mp="l0fxqo3117wp">
              📒 TOMO 5<br data-id="element-301" data-mp="g13cu8vpuawr" />
              Máquina de Re-Agendamiento
            </h3>
            <p className="font-montserrat text-sm text-gray-300 mb-4" data-id="element-302" data-mp="b2jq469asv3c">
              El protocolo de los 21 días para acompañar el regreso de tus clientas con valor, seguimiento y una experiencia memorable.
            </p>
            <p className="font-montserrat text-sm italic text-gray-400" data-id="element-303" data-mp="21btrtqce4bw">
              "Mis clientas vuelven porque se sienten acompañadas."
            </p>
          </Card>

          <Card className="bg-[#2A2A2A] border-gray-700 text-base transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-304" data-mp="quu8z4qdofvc">
            <h3 className="font-playfair text-xl font-bold mb-3 text-brand" data-id="element-305" data-mp="hz4px2cejxl4">
              📓 TOMO 6<br data-id="element-306" data-mp="m19kc3aocy8t" />
              Planner de Negocio
            </h3>
            <p className="font-montserrat text-sm text-gray-300 mb-4" data-id="element-307" data-mp="lzexukjr8y2m">
              Planillas de facturación, control de gastos, registro de clientas
              y metas mensuales. Todo en un sistema.
            </p>
            <p className="font-montserrat text-sm italic text-gray-400" data-id="element-308" data-mp="3v6zhizs60tqm">
              "Por fin tengo claridad de para dónde voy."
            </p>
          </Card>
        </div>

        <div className="max-w-2xl mx-auto bg-[#353332] p-8 rounded-xl border border-white/10" data-id="element-309" data-mp="34qdjkncfmff">
          <ul className="space-y-3 font-montserrat text-base text-gray-200" data-id="element-310" data-mp="1tdibg0joo0xz">
            <li className="flex items-center gap-3" data-id="element-311" data-mp="1xg56097qnzyv">
              <span className="text-brand" data-id="element-312" data-mp="3hygzjpqrudrd">✅</span> Scripts listos para copiar
              y pegar
            </li>
            <li className="flex items-center gap-3" data-id="element-313" data-mp="3dyexvgl1dkc3">
              <span className="text-brand" data-id="element-314" data-mp="3ros6ll5r532h">✅</span> Planillas y checklists
              imprimibles
            </li>
            <li className="flex items-center gap-3" data-id="element-315" data-mp="3mybsdyu3xdf2">
              <span className="text-brand" data-id="element-316" data-mp="3mwqxu97sluh7">✅</span> Ejemplos reales del rubro
              estética
            </li>
            <li className="flex items-center gap-3" data-id="element-317" data-mp="5jogty23fjmk">
              <span className="text-brand" data-id="element-318" data-mp="hfpf64vcpmk">✅</span> PDF editable desde el
              celular
            </li>
            <li className="flex items-center gap-3" data-id="element-319" data-mp="egyxy01le2ze">
              <span className="text-brand" data-id="element-320" data-mp="9jf5nw827pog">✅</span> Listo para usar desde hoy
            </li>
          </ul>
        </div>
      </Section>

      {/* Bonuses Section */}
      <Section bg="mid" data-id="element-321" data-mp="2g9vcvxymhpos">
        <div className="text-center mb-12" data-id="element-322" data-mp="2bajxotdwms9b">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold mb-4 text-dark" data-id="element-323" data-mp="2bbtxbn0eo8i2">
            🎁 4 BONOS ESTRATÉGICOS
          </h2>
          <p className="font-montserrat text-xl text-gray-700" data-id="element-324" data-mp="f9qjaihsaqsx">
            Siempre incluidos. Sin costo extra.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 max-w-4xl mx-auto" data-id="element-325" data-mp="p5bqqw5mgja2">
          <Card className="bg-white border-none shadow-md transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-326" data-mp="t7oj8ivcykow">
            <div className="text-sm font-bold text-brand uppercase tracking-wider mb-2" data-id="element-327" data-mp="y5goeel0k3b1">
              🎁 BONO 01
            </div>
            <h3 className="font-playfair text-2xl font-bold mb-3 text-dark" data-id="element-328" data-mp="1339qavfaab5i">
              100 Ganchos para Reels
            </h3>
            <p className="font-montserrat text-gray-600 mb-4" data-id="element-329" data-mp="1cuw8jbq1hahr">
              100 primeras líneas listas para que nadie pare de ver tu video.
              Porque si el primer segundo no engancha, nadie ve nada.
            </p>
            <p className="font-montserrat font-bold text-dark" data-id="element-330" data-mp="1lwvsabsfusoe">
              <span className="line-through text-gray-400 font-normal" data-id="element-331" data-mp="36dmvyg03qbpd">
                $8.000
              </span>{' '}
              → GRATIS
            </p>
          </Card>

          <Card className="bg-white border-none shadow-md transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-332" data-mp="31h4tjms8upg7">
            <div className="text-sm font-bold text-brand uppercase tracking-wider mb-2" data-id="element-333" data-mp="2sen5r3wxxor3">
              🎁 BONO 02
            </div>
            <h3 className="font-playfair text-2xl font-bold mb-3 text-dark" data-id="element-334" data-mp="3p32yt9z9eg8y">
              Fotografía con Celular
            </h3>
            <p className="font-montserrat text-gray-600 mb-4" data-id="element-335" data-mp="3l4vooxzawd6q">
              Fotos de tus trabajos que se ven increíbles con el celular que ya
              tenés. Sin cámara profesional. Sin editor costoso.
            </p>
            <p className="font-montserrat font-bold text-dark" data-id="element-336" data-mp="cmpkdpcj5x4p">
              <span className="line-through text-gray-400 font-normal" data-id="element-337" data-mp="coahnmq8bu69">
                $9.000
              </span>{' '}
              → GRATIS
            </p>
          </Card>

          <Card className="bg-white border-none shadow-md transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-338" data-mp="3cdagimprg1tx">
            <div className="text-sm font-bold text-brand uppercase tracking-wider mb-2" data-id="element-339" data-mp="3h6vc683vsjpy">
              🎁 BONO 03
            </div>
            <h3 className="font-playfair text-2xl font-bold mb-3 text-dark" data-id="element-340" data-mp="37efwxijyy98r">
              Guía de Promos Flash
            </h3>
            <p className="font-montserrat text-gray-600 mb-4" data-id="element-341" data-mp="3v5v53ryffkrx">
              30 promos listas para llenar la agenda en 24 horas. Sin bajar tus
              precios. Sin quedar como desesperada.
            </p>
            <p className="font-montserrat font-bold text-dark" data-id="element-342" data-mp="3m3c1h5mth44m">
              <span className="line-through text-gray-400 font-normal" data-id="element-343" data-mp="3q4pa1nhanlf8">
                $10.000
              </span>{' '}
              → GRATIS
            </p>
          </Card>

          <Card className="bg-white border-none shadow-md transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-344" data-mp="2eqbmykud7a09">
            <div className="text-sm font-bold text-brand uppercase tracking-wider mb-2" data-id="element-345" data-mp="275rcizjsshns">
              🎁 BONO 04
            </div>
            <h3 className="font-playfair text-2xl font-bold mb-3 text-dark" data-id="element-346" data-mp="227g4mud2ch87">
              Plantillas de Canva
            </h3>
            <p className="font-montserrat text-gray-600 mb-4" data-id="element-347" data-mp="2c5vuyv49nmgn">
              Tu Instagram empieza a verse como un negocio de verdad. Paletas,
              tipografías y los 10 diseños que toda profesional necesita.
            </p>
            <p className="font-montserrat font-bold text-dark" data-id="element-348" data-mp="1jhzr96ga4uad">
              <span className="line-through text-gray-400 font-normal" data-id="element-349" data-mp="1y649687id1s3">
                $9.000
              </span>{' '}
              → GRATIS
            </p>
          </Card>
        </div>

        <div className="bg-dark text-base text-center py-6 px-4 rounded-xl max-w-3xl mx-auto shadow-lg" data-id="element-350" data-mp="1tdjjnivmxaud">
          <p className="font-montserrat text-lg md:text-xl font-bold" data-id="element-351" data-mp="15ngx1iahox35">
            Valor total de los bonos:{' '}
            <span className="line-through text-gray-400 font-normal" data-id="element-352" data-mp="1g6s3qtyyimlf">
              $36.000
            </span>{' '}
            <span className="text-brand" data-id="element-353" data-mp="1c56vxn1a4yi3">→ GRATIS con tu Megakit</span>
          </p>
        </div>
      </Section>

      {/* Urgency Section */}
      <Section bg="dark" className="text-center" data-id="element-354" data-mp="174ixigaq1fdu">
        <h2 className="font-playfair text-3xl md:text-5xl font-bold mb-6" data-id="element-355" data-mp="127sjdyih8tv2">
          ⏰ PRECIO DE LANZAMIENTO
        </h2>
        <p className="font-montserrat text-lg text-gray-300 max-w-2xl mx-auto mb-10" data-id="element-356" data-mp="x8ze2tdcg95z">
          Este precio existe solo durante el lanzamiento. Cuando cierre, sube
          $8.000 ARS y no vuelve.
        </p>

        <div className="bg-[#222] inline-block py-6 px-8 md:px-12 rounded-2xl border border-gray-800 mb-6 shadow-2xl" data-id="element-357" data-mp="ogdvpedmk4ho">
          <Countdown data-id="element-358" data-mp="jeol1zubdsu4" />
        </div>

        <p className="font-montserrat text-brand font-bold mb-10" data-id="element-359" data-mp="ei7wx5n47eh1">
          ⚠️ Después sube $8.000 ARS. No vuelve.
        </p>

        <div className="max-w-md mx-auto bg-[#353332] p-6 rounded-xl border border-white/10" data-id="element-360" data-mp="9jwn2uwtl3yt">
          <p className="font-montserrat text-sm font-bold mb-3 flex items-center justify-between" data-id="element-361" data-mp="3vj135suidrhk">
            <span data-id="element-362" data-mp="4cq23wpi0qq8">🔥 Cupos al precio de lanzamiento</span>
            <span className="text-brand" data-id="element-363" data-mp="9cukxtdvpxjm">Quedan pocos</span>
          </p>
          <div className="w-full bg-gray-800 rounded-full h-4 mb-3 overflow-hidden" data-id="element-364" data-mp="9arn4n6hj04c">
            <div className="bg-brand h-4 rounded-full animate-[pulse_2s_ease-in-out_infinite]" style={{
            width: '71%'
          }} data-id="element-365" data-mp="ebffpdad3p0o"></div>
          </div>
          <p className="font-montserrat text-xs text-gray-400 text-right" data-id="element-366" data-mp="3hqjrb8jpxdry">
            71% de los cupos ya tomados
          </p>
        </div>
      </Section>
    </>;
};